export const getLastQuery = state => {
  const {router} = state;

  if (router.lastQuery) {
    return router.lastQuery;
  }

  return null;
};



/** WEBPACK FOOTER **
 ** ./src/modules/routing/selectors.js
 **/